<div
  #checkboxEl
  role="checkbox"
  [attr.aria-checked]="checked"
  [attr.aria-invalid]="invalid"
  [attr.aria-required]="required"
  [class.disabled]="isDisabled"
  tabindex="0"
  (click)="toggleCheckbox()"
  (keydown.space)="toggleCheckbox()"
  (blur)="handleOnTouch($event)"
>
  <div class="checkbox-box">
    <div></div>
    <opac-icon icon="checkbox_check"></opac-icon>
  </div>

  <span>
    <ng-content></ng-content>
  </span>

  <input type="hidden" [name]="name" [value]="checked">
</div>
